module.exports = __webpack_public_path__ + "media/images/icons/youtube_circle-ca7bcfd01a166f869cc41554c9df53df.svg";